import { formatISO, parseISO } from "date-fns";

export function getBatchKey(createdAt: Date | string): string {
    const d = typeof createdAt === "string" ? parseISO(createdAt) : createdAt;
    return formatISO(d, { representation: "complete" }).slice(0, 19);
}
